(function () {
  function initBezelVideo() {
    const video = document.querySelector(".rs-below-fold .bezel-video__player");
    if (!video) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.35 }
    );
    observer.observe(video);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBezelVideo);
  } else {
    initBezelVideo();
  }
})();
